module.exports = __webpack_public_path__ + "img/texto-uno.190f011f.png";